import { Component, OnInit } from '@angular/core';
import { BalanceService, config, ErrorStateService, VoucherRedeemModel, VoucherService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/utilities/boostrap-toast';

@Component({
  selector: 'fgb-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss'],
})
export class VouchersComponent implements OnInit {
  voucherCode: string;
  redemptionResult: string;
  disableButton: boolean;
  sucessfulRedemption: boolean;

  constructor(
    private voucherService: VoucherService,
    private balanceService: BalanceService,
    private translate: TranslateService,
    public toastService: ToastService,
    private errorService: ErrorStateService
  ) {}

  ngOnInit() {}

  redeemVoucher() {
    this.disableButton = true;

    if (!this.voucherCode) {
      this.showToast(this.translate.instant('voucher.code.not.valid'), 'toast-not-valid', 'notvalid');
      this.disableButton = false;
      return;
    }

    let voucher = new VoucherRedeemModel();
    voucher.VoucherCode = this.voucherCode;
    this.voucherService
      .redeemVoucher(voucher)
      .toPromise()
      .then((item) => {
        this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).pipe(take(1)).subscribe();
        this.redemptionResult = this.translate.instant('voucher.process.code');
      })
      .finally(() => {
        this.disableButton = false;
        if (this.errorService.hasErrors()) {
          this.showToast(this.translate.instant('voucher.code.error'), 'toast-fail', 'fail');
        } else {
          this.showToast(this.translate.instant('voucher.code.success'), 'toast-success', 'success');
        }
      });
  }

  showToast(message: string, className: string, type: 'success' | 'fail' | 'notvalid') {
    //clear all toasts
    this.toastService.clear();

    this.toastService.show(message, {
      classname: `${className}`,
      type: type,
    });
  }
}
